module.exports = __webpack_public_path__ + "static/media/report_load.f2e0aa5c.gif";